import { Button, CenteredContainer, Title } from '@nerdwallet/currency';
import Image from '@nerdwallet/react-image';
import { Impression } from '@nerdwallet/analytics/react/impression';
import appConfig from '@nerdwallet/app-config';

import styles from './banner.module.less';

const imageDesktop = `${appConfig.ASSETS_URL}/images/homepage/q2-mortgages-desktop.png`;
const imageTablet = `${appConfig.ASSETS_URL}/images/homepage/q2-mortgages-tablet.png`;
const imageMobile = `${appConfig.ASSETS_URL}/images/homepage/q2-mortgages-mobile.png`;

const altText = 'Home for sale';
const ctaText = 'Get Started';
const ctaLink = '/hub/category/mortgages?trk=homepage_mortgage_banner21';
const titleText = 'Easily compare and find the smartest mortgage for you';
const eyebrowText = 'First home? Forever home?';

const Banner = () => {
  return (
    <Impression entityName="homepage_mortgage_banner21">
      <CenteredContainer className={styles.bannerSection}>
        <div className={styles.bannerContainer}>
          <div className={styles.leftSide}>
            <div className={styles.textContainer}>
              <Title
                size="x-small"
                className={styles.eyebrowContainer}
                component="p"
              >
                {eyebrowText}
              </Title>
              <Title bold className={styles.titleContainer}>
                {titleText}
              </Title>
            </div>
            <div className={styles.ctaContainer}>
              <Button className={styles.bannerCta} href={ctaLink} primary>
                {ctaText}
              </Button>
            </div>
          </div>
          <div className={styles.rightSide}>
            <div className={styles.imageDesktopContainer}>
              <Image
                src={imageDesktop}
                alt={altText}
                className={styles.bannerIconFull}
                backgroundColor="transparent"
                naturalWidth={1600}
                naturalHeight={742}
              />
            </div>
            <div className={styles.imageTabletContainer}>
              <Image
                src={imageTablet}
                alt={altText}
                className={styles.bannerIconTablet}
                backgroundColor="transparent"
                naturalWidth={1000}
                naturalHeight={697}
              />
            </div>
            <div className={styles.imageMobileContainer}>
              <Image
                src={imageMobile}
                alt={altText}
                className={styles.bannerIconMobile}
                backgroundColor="transparent"
                naturalWidth={1000}
                naturalHeight={516}
              />
            </div>
          </div>
        </div>
      </CenteredContainer>
    </Impression>
  );
};

export default Banner;
